<template>
  <div class="child-sub-card">
    <BoardListCard
      v-for="(id, $index) in nonArchivedCardIds"
      :key="id"
      :card-id="id"
      :parent-card-id="parentCardId"
      :index="$index"
      :last-item="$index == nonArchivedCardIds.length - 1"
      :depth="depth"
      :depth-siblings="depthSiblingsArray($index)"
      :ancestors-card-ids="[...ancestorsCardIds, parentCardId]"
      :read-only="readOnly"
      :list-cards="nonArchivedCardIds"
      :layout="layout"
    />
  </div>
</template>

<script>
import { computed, defineAsyncComponent } from 'vue';
import useBoardEmbed from '@/boards/composables/useBoardEmbed';
import { getSprintKey } from '@/utilities/sprintKeys';
import useCurrentRole from '@/utilities/composables/useCurrentRole';

export default {
  name: 'CardSubCards',
  components: {
    BoardListCard: defineAsyncComponent(() => import('@/components/widgets/BoardListCard')),
  },
  props: {
    cardsIds: {
      type: Array,
      required: true,
    },
    parentCardId: {
      type: String,
      required: true,
    },
    depthSiblings: {
      type: Array,
      default: () => [],
    },
    depth: {
      type: Number,
      default: 0,
    },
    ancestorsCardIds: {
      type: Array,
      required: false,
      default: () => [],
    },
    layout: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup() {
    const { embeddedBoardAttributes, embed } = useBoardEmbed();
    const { isGuestReader } = useCurrentRole();
    const readOnly = computed(
      () => embeddedBoardAttributes.value?.readOnly || isGuestReader.value || false
    );

    return {
      embeddedBoardAttributes,
      embed,
      readOnly,
    };
  },
  computed: {
    depthSiblingsArray() {
      return (index) => {
        if (this.nonArchivedCardIds.length > 1 && index < this.nonArchivedCardIds.length - 1) {
          const depthSiblings = [...this.depthSiblings];
          depthSiblings.push(this.depth);
          return depthSiblings;
        }
        return this.depthSiblings;
      };
    },
    nonArchivedCardIds() {
      return this.cardsIds?.filter((cardId) => {
        const card = this.getCard(cardId);
        return !card.archived;
      });
    },
  },

  mounted() {
    this.cardsIds?.forEach((cardId) => {
      if (Object.keys(this.getCard(cardId)).length && !this.getCard(cardId).partially_loaded)
        return;

      this.$store.dispatch('fetchCard', { cardId }).then((card) => {
        const resourceKey = card.sprint_id
          ? getSprintKey(card.project_id, card.sprint_id)
          : card.board_id;
        const flatBoard = this.$store.getters.getFlatBoards[resourceKey] || {};
        if (!this.$isBoardFullyLoaded(flatBoard, !!card.sprint_id)) {
          if (!!card.sprint_id) {
            this.$store.dispatch('getSprint', {
              projectId: card.project_id,
              sprintId: card.sprint_id,
            });
            return;
          }
          this.$store.dispatch('fetchBoard', { boardId: card.board_id });
        }
      });
    });
  },
  methods: {
    getCard(cardId) {
      return this.$store.getters.getCards[cardId] || {};
    },
  },
};
</script>

<style lang="scss">
.child-sub-card {
  .board-list-card-wrap {
    border: none;
    border-top: var(--dividers) solid 1px;
  }
}
</style>
